import InputField from "../../../../../components/Forms/Input/InputField";
import DatePicker from "../../../../../components/Forms/DatePicker/DatePicker";
import ButtonCustom from "../../../../../pages/UiElements/ButtonCustom";

interface Props {
  label: string;
  name: string;
  search: string;
  searchDate: string;

  onSearchChange: (value: string) => void;
  onDateChange: (value: string) => void;
  onClear: () => void;

  disabled?: boolean;
  required?: boolean;
}

const SearchSelectionFilters = ({
  label,
  name,
  search,
  searchDate,
  onSearchChange,
  onDateChange,
  onClear,
  disabled = false,
  required = false,
}: Props) => {
  const hasFilters =
    !!search.trim() || !!searchDate;

  return (
    <div className="px-6 pt-5">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <InputField
          label={label}
          name={name}
          type="text"
          value={search}
          onChange={(e) =>
            onSearchChange(e.target.value)
          }
          placeholder="Buscar por número..."
          iconKey="search"
          disabled={disabled}
          required={required}
        />

        <DatePicker
          label="Fecha emisión"
          name="issueDate"
          value={searchDate}
          onChange={onDateChange}
          iconKey="calendar"
          disabled={disabled}
        />
      </div>

      {/* Acción limpiar */}
      <div className="mt-2 flex justify-end">
        <ButtonCustom
          text="Limpiar filtros"
          onClick={onClear}
          iconKey="close"
          variant="danger"
          size="sm"
          type="button"
          disabled={disabled || !hasFilters}
          rounded="md"
        />
      </div>
    </div>
  );
};

export default SearchSelectionFilters;